import { useLocation } from 'react-router-dom';

export function useSearchParams(): URLSearchParams {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return searchParams;
}
